import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { getUiBrowser } from '@/redux/modules/browser';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styles from './BannerOutdatedBrowser.module.scss';
import { useSelector } from 'react-redux';

type Props = {};

// eslint-disable-next-line no-empty-pattern
const BannerOutdatedBrowser = ({}: Props) => {
    const { isOutdated, majorVersion, name }: any = useSelector(getUiBrowser);
    if (!isOutdated) {
        return null;
    }

    const formalName = <FormattedMessage id={name || '?'} />;
    const chrome = (
        <Link rel="noopener" target="_blank" to="https://www.google.com/chrome/">
            <FormattedMessage id="chrome" />
        </Link>
    );
    const firefox = (
        <Link rel="noopener" target="_blank" to="https://www.mozilla.org/firefox/new/">
            <FormattedMessage id="firefox" />
        </Link>
    );
    const edge = (
        <Link rel="noopener" target="_blank" to="https://www.microsoft.com/edge">
            <FormattedMessage id="edge" />
        </Link>
    );

    return (
        <div className={styles['la-notification-bar']}>
            <div className={styles['notification-message']}>
                <div className={styles['message-status']}>
                    <FontAwesomeIcon className={styles.icon} icon={faExclamationCircle} />
                </div>
                <div className={styles['message-body']}>
                    <span className={styles['message-headline']}>
                        <FormattedMessage
                            id="did_you_know_that_your_web_browser"
                            values={{ formalName, majorVersion }}
                        />
                    </span>
                    <div>
                        <FormattedMessage id="browsers_for_best_experience" values={{ chrome, edge, firefox }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

// because browser will never update we can keep memo
export default React.memo(BannerOutdatedBrowser);
